import CustomerLeadType from 'types/model/customerLead';
import ContactInfo from './ContactInfo';
import { observable, action, computed } from 'mobx';

export class CustomerLead {
  @observable public companyName: string;
  @observable public mainContactInfo: ContactInfo;
  @observable public secondaryContactInfo?: ContactInfo;
  @observable public countryId?: number;
  @observable public city?: string;
  @observable public leadSourceId?: number;
  @observable public website?: string;
  @observable public originScore?: number;
  @observable public valuesScore?: number;
  @observable public sizeScore?: number;

  constructor(customer_lead: CustomerLeadType) {
    this.companyName = customer_lead.company_name;

    this.mainContactInfo = new ContactInfo(customer_lead.main_contact_info);
    this.secondaryContactInfo = new ContactInfo(customer_lead.secondary_contact_info);
    this.countryId = customer_lead.country_id;
    this.city = customer_lead.city;
    this.leadSourceId = customer_lead.lead_source_id;
    this.website = customer_lead.website;
    this.originScore = customer_lead.origin_score ?? undefined;
    this.valuesScore = customer_lead.values_score ?? undefined;
    this.sizeScore = customer_lead.size_score ?? undefined;
  }
  @action setCompanyName = (companyName: string) => {
    this.companyName = companyName;
  };

  @action setCountryId = (countryId: string) => {
    this.countryId = countryId ? Number(countryId) : undefined;
    this.city = undefined;
  };

  @action setCity = (city: string) => {
    this.city = city;
  };

  @action setLeadSourceId = (leadSourceId: string) => {
    this.leadSourceId = leadSourceId ? Number(leadSourceId) : undefined;
  };

  @action setWebsite = (website: string) => {
    this.website = website;
  };

  @action setOriginScore = (originScore: string) => {
    this.originScore = originScore === '' ? undefined : Number(originScore);
  };

  @action setValuesScore = (valuesScore: string) => {
    this.valuesScore = valuesScore === '' ? undefined : Number(valuesScore);
  };

  @action setSizeScore = (sizeScore: string) => {
    this.sizeScore = sizeScore === '' ? undefined : Number(sizeScore);
  };

  @computed get prospectingScore(): number | undefined {
    const { originScore, valuesScore, sizeScore } = this;
    if (
      originScore === undefined ||
      valuesScore === undefined ||
      sizeScore === undefined
    ) {
      return undefined;
    }
    return originScore + valuesScore + sizeScore;
  }

  @computed get priorityTier(): string | undefined {
    if (this.prospectingScore === undefined) {
      return undefined;
    }
    if (this.prospectingScore >= 13) {
      return 'high';
    }
    if (this.prospectingScore >= 7) {
      return 'medium';
    }
    return 'low';
  }
}
